<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 展示来場状況ダウンロードの説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>展示来場状況ダウンロードの説明</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/entrance-exit-exhibit-transit-download.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> 作成ボタン
        </div>
        <div class="manual-explain">
          クリックすることで作成画面が表示されます。<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> 削除ボタン
        </div>
        <div class="manual-explain">
          クリックすることで選択したファイルを削除します。<br>
          ボタンは、一覧の削除チェックボックスにチェックを入れる事で活性化されます。
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          展示来場状況ダウンロードファイル一覧に表示されているデータのフィルタリングを行います。<br>
          ※フィルタリングの対象: メモ
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> 展示来場状況ダウンロードファイル一覧
        </div>
        <div class="manual-explain">
          作成済みの展示来場状況ダウンロードファイル一覧が表示されます。<br>
          編集アイコンをクリックすることで編集画面が表示されます。<br>
          また、ダウンロードボタンをクリックすることで作成されたファイルをダウンロードします。<br>
          ※ダウンロードボタンは、ファイル作成が完了した段階で活性化されます。<br>
          ※展示来場状況の件数が０件の場合は活性化されません。
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Exhibit Visitor Status Download
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Exhibit Visitor Status Download</span></mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_entrance-exit-exhibit-transit-download.png" width="100%">
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Add Button
        </div>
        <div class="manual-explain">
          Click to display the create screen.<br>
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> Delete Button
        </div>
        <div class="manual-explain">
          Click to delete the selected files.<br>
          The button is activated by checking the delete checkboxes in the list.
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Filter
        </div>
        <div class="manual-explain">
          Filters the data displayed in the exhibit visitor status download file list.<br>
          *Filtering target: Memo
        </div>

        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Exhibit Visitor Status Download File List
        </div>
        <div class="manual-explain">
          Displays a list of created exhibit visitor status download files.<br>
          Click the edit icon to display the edit screen.<br>
          Also, click the download button to download the created file.<br>
          *The download button is activated when file creation is completed.<br>
          *It will not be activated if the number of exhibit visitor status records is 0.
        </div>

      </mat-card-content>
    </mat-card>

  </div>
</div>